import React, { forwardRef, ForwardRefRenderFunction } from 'react'

type Props = {
  youtubeId: string
}

const DigestMovieContent: ForwardRefRenderFunction<HTMLDivElement, Props> = (
  { youtubeId },
  ref
) => (
  <div
    ref={ref}
    className="flex lg:px-[8.7vw] pt-[8.3vw] lg:pt-[3.3vw] pb-[11.5vw] lg:pb-[4.3vw] bg-[#F7F6F5]"
  >
    <div className="relative pb-[56.25%] w-full h-0">
      <iframe
        className="absolute top-0 left-0 w-full h-full"
        src={`https://www.youtube.com/embed/${youtubeId}?autoplay=0`}
        frameBorder="0"
        width="100%"
        allow="accelerometer; autoplay; clipboard-write=1; encrypted-media; gyroscope; picture-in-picture=1"
        allowFullScreen
      ></iframe>
    </div>
  </div>
)

DigestMovieContent.displayName = 'DigestMovieContent'

export const RefWrappedDigestMovieContent = forwardRef(DigestMovieContent)
